module.exports = __webpack_public_path__ + "img/donghua.82680f4b.png";